import popupWindow from '@js/components/popupWindow';
import {initFavoritesOrganization} from '@js/modules/public/organizations/index';
import ymaps from 'ymaps';
import {enums} from '@js/helpers/enums';
import {routes} from "@js/helpers/routes";
import {sendRequest} from "@js/utils";
import Notifier from "@js/components/Notifier";
import "@js/modules/public/organizations/details/carusel";

$(() => {
    window.addEventListener('resize', checkWidthScreen);
    popupWindow();
    initFavoritesOrganization('.favorite');
    showModalForm();
    sendApplicant();
    if ($('.organization-radar').length) {
        import(/* webpackChunkName: "highchart" */'@entries/chart').then(() => {
            initRadarChart($('.organization-radar').attr('id'));
        });
    }
    if ($('.organization-pie').length) {
        import(/* webpackChunkName: "highchart" */'@entries/chart').then(() => {
            initPieChart($('.organization-pie').attr('id'));
        });
    }
    $('body')
        .on('click', '.accred_table_control', function () {
            toggleAchievementsList($(this), $('#accred_table'), $('.accred_table_control'));
        })
        .on('click', '.pnar_table_control', function () {
            toggleAchievementsList($(this), $('#pnar_table'), $('.pnar_table_control'));
        })
        .on('click', '.pgar_table_control', function () {
            toggleAchievementsList($(this), $('#pgar_table'), $('.pgar_table_control'));
        })
        .on('click', '#dropdown_naprs, #dropdown_programs', function () {
            toggleProgramDropdown(this);
        });
    checkWidthScreen();
    const {commissions, yandexMapApiKey, organizationAddress} = window;
    let specifyCommissions = [];
    if (typeof commissions !== 'undefined' && commissions.length > 0) {
        specifyCommissions = commissions;
    } else if (typeof organizationAddress !== 'undefined' && organizationAddress !== '') {
        specifyCommissions.push({address: organizationAddress});
    }
    if (specifyCommissions.length > 0) {
        ymaps
            .load(`https://api-maps.yandex.ru/2.1/?apikey=${yandexMapApiKey}&lang=ru_RU`)
            .then((maps) => {
                const map = new maps.Map('ymap', {
                    center: [55.75399399999374, 37.62209300000001],
                    zoom: 7,
                });
                $('.ymaps-2-1-79-map-copyrights-promo').remove();
                $('.ymaps-2-1-79-controls__control_toolbar').remove();
                for (let i = 0; i < specifyCommissions.length; i += 1) {
                    const {address} = specifyCommissions[i];
                    maps.geocode(address, {
                        results: 1,
                    }).then((res) => {
                        // Выбираем первый результат геокодирования.
                        const firstGeoObject = res.geoObjects.get(0);
                        // Координаты геообъекта.
                        specifyCommissions[i].coordinates = firstGeoObject.geometry.getCoordinates();
                        firstGeoObject.options.set('preset', 'islands#darkBlueDotIconWithCaption');
                        // Получаем строку с адресом и выводим в иконке геообъекта.
                        firstGeoObject.properties.set('iconCaption', firstGeoObject.getAddressLine());
                        // Добавляем первый найденный геообъект на карту.
                        map.geoObjects.add(firstGeoObject);
                        if (i === 0) {
                            map.setCenter(specifyCommissions[0].coordinates, 13);
                        }
                        if (specifyCommissions.length > 1 && i === specifyCommissions.length - 1) {
                            map.setBounds(map.geoObjects.getBounds()); // Установить границы карты по объектам
                            map.setZoom(map.getZoom() - 0.7);
                            // Создадим собственный макет выпадающего списка.
                            const dropdownElement = "<div class='btn-group'><button id='my-listbox-header' "
                                + "class='btn btn-success dropdown-toggle' data-toggle='dropdown' "
                                + ' aria-haspopup="true" aria-expanded="false">'
                                + "Веберите приемную комиссию <span class='caret'></span>"
                                + '</button>'
                                + "<ul id='my-listbox'"
                                + " class='dropdown-menu' role='menu' aria-labelledby='dropdownMenu'></ul></div>";
                            const ListBoxLayout = maps.templateLayoutFactory.createClass(dropdownElement, {
                                build() {
                                    ListBoxLayout.superclass.build.call(this);
                                    this.childContainerElement = $('#my-listbox').get(0);
                                    this.events.fire('childcontainerchange', {
                                        newChildContainerElement: this.childContainerElement,
                                        oldChildContainerElement: null,
                                    });
                                },
                                getChildContainerElement() {
                                    return this.childContainerElement;
                                },
                                clear() {
                                    this.events.fire('childcontainerchange', {
                                        newChildContainerElement: null,
                                        oldChildContainerElement: this.childContainerElement,
                                    });
                                    this.childContainerElement = null;
                                    ListBoxLayout.superclass.clear.call(this);
                                },
                            });
                            const listBoxElement = '<li style="margin: 0 5px 0 5px; cursor: pointer; width: auto;">{{data.content}}</li>';
                            const ListBoxItemLayout = maps.templateLayoutFactory.createClass(listBoxElement);
                            // Создадим 2 пункта выпадающего списка
                            const listBoxItems = [];
                            for (const j in commissions) {
                                listBoxItems.push(new maps.control.ListBoxItem({
                                    data: {
                                        content: commissions[j].address,
                                        center: commissions[j].coordinates,
                                        zoom: 10,
                                    },
                                }));
                            }
                            // Теперь создадим список, содержащий 2 пункта.
                            const listBox = new maps.control.ListBox({
                                items: listBoxItems,
                                data: {
                                    title: 'Выберите приемную комиссию',
                                },
                                options: {
                                    layout: ListBoxLayout,
                                    itemLayout: ListBoxItemLayout,
                                },
                            });

                            listBox.events.add('click', (e) => {
                                const item = e.get('target');
                                if (item !== listBox) {
                                    map.setCenter(
                                        item.data.get('center'),
                                        item.data.get('zoom'),
                                    );
                                }
                            });
                            map.controls.add(listBox, {float: 'left'});
                        }
                    }).catch((error) => {
                        return console.log('Failed to load Yandex Maps', error);
                    });
                }
            })
            .catch((error) => {
                return console.log('Failed to load Yandex Maps', error);
            });
    } else {
        $('#comission').hide();
    }
});

export function showModalForm() {
    const $modal = $('#modal-commission-messsage');
    $('body')
        .on('click', '.show-form', function () {
            const errorBlock = $('.errors');
            errorBlock.hide();
            $modal.modal('show');
        })
        .on('click', '.close', function () {
            $modal.modal('hide');
        });
}

export function sendApplicant() {
    const $modal = $('#modal-commission-messsage');
    const $form = $('#form-commission-messsage');
    $modal.on('click', '.send-applicant', function () {
        $(this).attr('disabled', true);
        $(this).text('Отправка...');
        const data = $form.serialize();
        const location = routes.public.organizations.commissions.sendApplicant();
        sendRequest('post', `${location}`, data, (res) => {
            if (!res?.success) {
                const errorBlock = $('.errors');
                errorBlock.html(res?.errors);
                errorBlock.show();
            } else {
                $modal.modal('hide');
                const notifier = new Notifier();
                notifier.success(res?.message);
            }
            $(this).attr('disabled', false);
            $(this).text('Отправить');
        });
    })
}

export function toggleAchievementsList($controlElement, $table, $otherControls) {
    const $organizationBlock = ($controlElement).closest('.organization__block-item');
    if ($table.hasClass('hidden')) {
        $($organizationBlock).removeClass('organization__block-item_fix-height');
        $otherControls.html('Свернуть');
        $table.removeClass('hidden');
    } else {
        $table.addClass('hidden');
        $otherControls.html('Подробнее');
        $organizationBlock.addClass('organization__block-item_fix-height');
    }
}

export function toggleProgramDropdown($dropdown, isResize = false, isClickDropdown = true) {
    const $arrows = $($dropdown).find('img');
    const $parent = $($dropdown).closest('.organization__block-item');
    const $programsList = $($parent).next('.organization__block-item');
    const isOpenDropdown = Boolean($($dropdown).attr('data-open'));
    if (isOpenDropdown) {
        $programsList.show();
    } else {
        $programsList.hide();
    }
    if (isClickDropdown) {
        $arrows.each((index) => {
            if ($($arrows[index]).hasClass('block-item__dropdown_hidden')) {
                $($arrows[index]).removeClass('block-item__dropdown_hidden');
            } else {
                $($arrows[index]).addClass('block-item__dropdown_hidden');
            }
        });
        if (isOpenDropdown) {
            $($dropdown).attr('data-open', '');
            $programsList.addClass('mobile-hidden');
            $programsList.hide();
        } else {
            $($dropdown).attr('data-open', 'open');
            $programsList.removeClass('mobile-hidden');
            $programsList.show();
        }
    }
    if (isResize) {
        $programsList.show();
    }
}

function checkWidthScreen() {
    const isTablet = $('body').width() >= parseInt(enums.adaptive.bodyWidthForTablet, 10);
    toggleProgramDropdown($('#dropdown_programs'), isTablet, false);
    toggleProgramDropdown($('#dropdown_naprs'), isTablet, false);
}

export function initRadarChart(containerId) {
    const {epiura} = window;
    const categories = [
        'Количество студентов',
        'Количество направлений подготовки',
        'Доступность платного обучения',
        'Остепененность преподавателей',
        'Средняя зарплата выпускников',
    ];
    if (categories.length > epiura.epiuraData.realData.length) {
        categories.splice(2, 1);
    }
    const epiuraData = epiura.epiuraData.serieData;
    const medians = epiura.epiuraData.serieMedians;
    if (epiuraData[epiuraData.length - 1] === null || epiuraData[epiuraData.length - 1] === 0) {
        categories.splice(categories.length - 1, 1);
        epiuraData.splice(epiuraData.length - 1, 1);
        medians.splice(medians.length - 1, 1);
    }
    const settings = {
        chart: {
            polar: true,
            type: 'line',
        },
        title: {
            text: '',
        },
        pane: {
            size: '80%',
        },

        xAxis: {
            categories: categories,
            tickmarkPlacement: 'on',
            lineWidth: 0,
        },

        yAxis: {
            gridLineInterpolation: 'polygon',
            lineWidth: 0,
            min: 0,
            max: epiura.max_value,
            labels: {
                enabled: false,
            },
        },

        series: [{
            type: 'line',
            name: 'Значение',
            data: epiuraData,
            pointPlacement: 'on',
        }, {
            type: 'line',
            name: 'Медиана',
            data: medians,
            pointPlacement: 'between',
        }],

        tooltip: {
            shared: false,
            formatter() {
                let message = '';
                switch (this.series.name) {
                    case 'Значение':
                        message = epiura.epiuraData.realData[this.point.index];
                        break;
                    case 'Медиана':
                        message = epiura.epiuraData.realMedians[this.point.index];
                        break;
                    default:
                }
                return `<span style="color:${this.series.color}">${this.series.name}: <b>${message}</b><br/>`;
            },
        },

        legend: {
            enabled: false,
        },

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500,
                },
                chartOptions: {
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal',
                    },
                    pane: {
                        size: '59%',
                    },
                },
            }],
        },
    };
    new Highcharts.chart(containerId, settings);
    $('.highcharts-credits').hide();
}

export function initPieChart(containerId) {
    const {pie} = window;
    if (pie.pieData.length) {
        const pieData = [];
        for (let i = 0; i < pie.pieData.length; i += 1) {
            const name = `${pie.pieData[i].name}`;
            const y = pie.pieData[i].value;
            pieData.push(
                {
                    name,
                    y,
                },
            );
        }
        const settings = {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
            },
            title: {
                text: '',
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
            },
            accessibility: {
                point: {
                    valueSuffix: '%',
                },
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false,
                    },
                    showInLegend: true,
                    colors: [
                        '#45AEB2',
                        '#F2651C',
                        '#F9AC7C',
                        '#A6A9AC',
                        '#676766',
                        '#AED6D8',
                        '#FFE9B0',
                        '#FFCE30',
                    ],
                },
            },
            series: [{
                name: 'Значение',
                colorByPoint: true,
                data: pieData,
            }],
        };
        new Highcharts.chart(containerId, settings);
        $('.highcharts-credits').hide();
    }
}


